import { Routes } from '@angular/router';
import { DashboardComponent } from './core/layout/pages/dashboard/dashboard.component';
import { MainDashboardComponent } from './core/layout/pages/main-dashboard/main-dashboard.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'main-dashboard',
    pathMatch: 'full',
  },
  {
    path: 'main-dashboard',
    component: MainDashboardComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'data-source',
    loadComponent: () =>
      import('./core/layout/pages/data-source/data-source.component').then(
        (m) => m.DataSourceComponent
      ),
  },
  { path: '**', redirectTo: 'main-dashboard', pathMatch: 'full' },
];
